/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { workloadIdentitiesList } from "../funcs/workloadIdentitiesList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { WorkloadIdentityPolicy } from "../models/components/workloadidentitypolicy.js";
import {
  ListWorkloadIdentitiesRequest,
  ListWorkloadIdentitiesSecurity,
} from "../models/operations/listworkloadidentities.js";
import { unwrapAsync } from "../types/fp.js";
export type WorkloadIdentitiesQueryData = WorkloadIdentityPolicy;

export function prefetchWorkloadIdentities(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListWorkloadIdentitiesRequest | undefined,
  security?: ListWorkloadIdentitiesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildWorkloadIdentitiesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildWorkloadIdentitiesQuery(
  client$: GramCore,
  request?: ListWorkloadIdentitiesRequest | undefined,
  security?: ListWorkloadIdentitiesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<WorkloadIdentitiesQueryData>;
} {
  return {
    queryKey: queryKeyWorkloadIdentities({
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function workloadIdentitiesQueryFn(
      ctx,
    ): Promise<WorkloadIdentitiesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(workloadIdentitiesList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyWorkloadIdentities(
  parameters: {
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "workloadIdentities", "list", parameters];
}
